import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";
import { generateFilterColumn } from "../../filter";
import { Quotation } from "@/v2/types";
import AccessControl from "../../rbac/AccessControl";
import QuotationsDeleteButton from "../../ui/button/delete/Quotations";
import PrintQuotation from "../../pages/quotation/Print";

type T = Quotation;

const columnHelper = createColumnHelper<T>();

const QuotationColumnDefinition: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "quotation_number",
        headingText: "Quotation number",
    },
    {
        id: "reference_number",
        headingText: "Reference Number",
    },
    {
        id: "client.full_name",
        headingText: "Client Name",
    },
    {
        id: "subject",
        headingText: "Subject",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "quotation_date",
        headingText: "Date",
        headingCellType: "text-center",
        cellType: "date",
    },
    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2">
                    <Link to={`/quotation/${row.id}`}>
                        <Button variant={"outline"} size={"sm"}>
                            <Eye className="h-4 w-4" />
                        </Button>
                    </Link>

                    <PrintQuotation data={row} />

                    <AccessControl
                        module="QUOTATION_MANAGEMENT"
                        requestedAccess="PUT"
                    >
                        <Link to={`/quotation/edit/${row.id}`}>
                            <Button variant={"outline"} size={"sm"}>
                                <Pencil className="h-4 w-4" />
                            </Button>
                        </Link>
                    </AccessControl>

                    <AccessControl
                        module="QUOTATION_MANAGEMENT"
                        requestedAccess="DELETE"
                    >
                        <QuotationsDeleteButton id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const QuotationColumn = buildColumns<T>(
    columnHelper,
    QuotationColumnDefinition,
);

const QuotationFilterColumn = generateFilterColumn<T>(
    QuotationColumnDefinition,
    {
        removeIds: [],
        addFilterId: { "client.full_name": "clients.full_name" },
    },
);

export { QuotationColumn, QuotationFilterColumn };
